import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'

export const person_participations = {

  namespaced: true,

  state: {
    participations: [],
    all: null,
  },

  getters: {
    participations: state => state.participations,
    all: state => state.all,
  },

  mutations: {
    setParticipations(state, participations) { state.participations = participations },
    setAll(state, all) { state.all = all },
  },

  actions: {

    async getParticipations({ commit }) {
      const participations = await Vue.axios.get(API_URL + '/persons/' + router.currentRoute.params.id + '/participations');
      commit('setParticipations', participations.data);
      commit('setProgress', false, { root: true });
    },

    async updateState({ state, commit }, values) {
      const participation = await Vue.axios.put(API_URL + '/participations/' + values.id, { state_id: values.state_id });
      commit('setProgress', false, { root: true });
      if (values.ckey != undefined) {
        state.participations[values.skey].presentations[values.ckey].participations[values.pkey].state_id = participation.data.state_id;
      } else {
        state.participations[values.skey].participations[values.pkey].state_id = participation.data.state_id;
      }
    },

    async updateStates({ state, commit }, values) {
      const participations = await Vue.axios.put(API_URL + '/persons/' + router.currentRoute.params.id + '/participations', { state_id: values.state_id });

      if (state.participations && state.participations.length > 0) {
        for (let i = 0; i < state.participations.length; i++) {
          if (state.participations[i].participations && state.participations[i].participations.length > 0) {
            for (let j = 0; j < state.participations[i].participations.length; j++) {
              state.participations[i].participations[j].state_id = participations.data.state_id;
            }
          }
          if (state.participations[i].presentations && state.participations[i].presentations.length > 0) {
            for (let j = 0; j < state.participations[i].presentations.length; j++) {
              if (state.participations[i].presentations[j].participations && state.participations[i].presentations[j].participations.length > 0) {
                for (let k = 0; k < state.participations[i].presentations[j].participations.length; k++) {
                  state.participations[i].presentations[j].participations[k].state_id = participations.data.state_id;
                }
              }
            }
          }
        }
      }
      commit('setAll', null);
      commit('setProgress', false, { root: true });
    },

  }
}
